import $ from 'jquery';
import connectFilterNotifications from 'legacy/javascripts/notification.js';

$(function () {
  var emailNotificationsOn = connectFilterNotifications.emailNotificationsOn();
  var emailNotificationEnabled =
    $('.js-notifications-bell').attr('data-on') === 'true';
  var $filterForm = $('.js-filter-form');
  if (!emailNotificationsOn || !$filterForm.length) {
    return;
  }

  var $notificationsContainer = $('.js-notifications-container');
  var $notificationsControlBell = $('.js-notifications-bell');
  var permissionSlide = {
    default: 'permission_request',
    granted: 'permission_success',
    denied: 'permission_declined',
  };

  var onNotificationGrant = function () {
    $('.js-grant-notification').html('Continue');
    $notificationsControlBell.attr('data-on', 'true');
  };

  var onNotificationClear = function () {
    if (!emailNotificationEnabled) {
      $notificationsControlBell.attr('data-on', 'false');
    }
  };

  var goToSlide = function (slideName) {
    $('.js-content-slide').addClass('hidden');
    $('.js-content-slide[data-name="' + slideName + '"]').removeClass('hidden');

    if (slideName === 'filter_selection' || slideName === 'filter_update') {
      $('.js-stream-overlay').removeClass('hidden');
    } else if (slideName === 'permission_success') {
      $notificationsControlBell.attr('data-on', 'true');
      connectFilterNotifications.sendAlert();
    } else {
      $('.js-stream-overlay').addClass('hidden');
    }
  };

  var onNotificationDeny = function () {
    $notificationsControlBell.attr('data-on', 'false');
    goToSlide('permission_declined');
  };

  $('.js-save-notification-filters').click(function () {
    var filterSaveType;

    goToSlide(permissionSlide[window.Notification.permission]);
    filterSaveType = $notificationsContainer.attr('data-save-type');

    if (filterSaveType == 'create' && connectFilterNotifications.isIE()) {
      var message = $('.js-browser-notification').data().ieMessage;
      if (!window.confirm(message)) {
        return;
      }
    }
    connectFilterNotifications.setFilters(
      $filterForm,
      onNotificationGrant,
      onNotificationDeny
    );
  });

  $('.js-clear-notification-filters').click(function () {
    connectFilterNotifications.clear();
    onNotificationClear();
  });

  $('.js-nav-tab').click(function () {
    var activeTab = $(this).attr('data-tab');
    $notificationsContainer.attr('data-tab', activeTab);
    $('.js-nav-tab').removeClass('active');
    $(this).addClass('active');
    if (activeTab === 'email') {
      $('.js-stream-overlay').addClass('hidden');
      $('.js-disable-email-notification').toggleClass(
        'hidden',
        !emailNotificationEnabled
      );
    }
  });

  $('.js-notifications-bell, .js-close-card').click(function () {
    var slideName = connectFilterNotifications.isOn()
      ? 'notification_on'
      : 'notification_off';
    if ($notificationsContainer.attr('data-hide') === 'true') {
      $('.js-panel-status').addClass('hidden');
      $('.js-notifications-panel').removeClass('hidden');
      $notificationsContainer.attr('data-hide', 'false');
      goToSlide(slideName);
      $('.js-nav-tab[data-tab="browser"]').click();
    } else {
      $notificationsContainer.attr('data-hide', 'true');
      $('.js-stream-overlay').addClass('hidden');
    }
  });

  $('.js-setup-notification, .js-edit-notification').click(function () {
    var filterSaveType = $(this).attr('data-save-type');
    $notificationsContainer.attr('data-save-type', filterSaveType);
    var isUpdate = filterSaveType === 'update';
    if (isUpdate) {
      connectFilterNotifications.setStreamFilters();
    }
    goToSlide(isUpdate ? 'filter_update' : 'filter_selection');
  });

  $('.js-grant-notification').click(function () {
    goToSlide(permissionSlide[window.Notification.permission]);
  });

  $('.js-reset-card').click(function () {
    var slideName = connectFilterNotifications.isOn()
      ? 'notification_on'
      : 'notification_off';
    goToSlide(slideName);
  });

  connectFilterNotifications.isOn()
    ? onNotificationGrant()
    : onNotificationClear();

  var notificationType = window.location.search.split('notification=')[1];
  if (['email', 'browser'].indexOf(notificationType) > -1) {
    $('.js-notifications-bell').click();
    $('.js-nav-tab[data-tab=' + notificationType + ']').click();
  }

  $('.js-email-notification-settings-form').on('ajax:beforeSend', function () {
    var emailNotificationType = $(
      '.js-email-notification-settings-form input[type="radio"]:checked'
    ).val();
    emailNotificationEnabled = emailNotificationType ? true : false;
  });

  $('.js-email-notification-settings-form').on('ajax:success', function () {
    if (connectFilterNotifications.isOn() || emailNotificationEnabled) {
      onNotificationGrant();
    } else {
      onNotificationClear();
    }
    $('.js-notifications-panel').addClass('hidden');
    $('.js-panel-status.email-success').removeClass('hidden');
  });

  $('.js-email-notification-settings-form').on('ajax:error', function () {
    $('.js-notifications-panel').addClass('hidden');
    $('.js-panel-status.email-error').removeClass('hidden');
  });
});
